// 2TACTIC homepage section: collection tabs, quick add, shop the look, reviews coverflow.
// Every instance of the section starts on its own; the theme editor re-runs it when the section reloads.
(()=>{
if(window.T2Home){window.T2Home.all();return}
const SIZE_ORDER=['XS','S','M','L','XL','XXL','2XL','3XL','4XL','5XL','SMALL','MEDIUM','LARGE','X-LARGE'];
const sizeRank=v=>{const k=String(v).toUpperCase().split(' ')[0];const i=SIZE_ORDER.indexOf(k);return i<0?99:i};
const SWATCH={black:'#111',white:'#fff',green:'#4B5A3A',khaki:'#B9A57E',tan:'#C2A27A',acu:'linear-gradient(135deg,#8E8F80,#B8B5A3 50%,#6E7062)',grey:'#888',gray:'#888',blue:'#2F4A6B','royal blue':'#2B4FA8',camo:'linear-gradient(135deg,#6B6B47,#9A8C62 40%,#4A4F35 70%,#7D7352)','brown camo':'linear-gradient(135deg,#6E5538,#A08460 45%,#4B3B28 75%)','dark camo':'linear-gradient(135deg,#2F3328,#555B45 45%,#1E211B 75%)','black multicam':'linear-gradient(135deg,#111,#3B3D33 45%,#1A1A17 75%)',cp:'linear-gradient(135deg,#8C7B5A,#B7A47C 40%,#5E5A3E 70%)','dry grass':'#B49A63',woodland:'linear-gradient(135deg,#3E4A2C,#6D6A3E 45%,#2C2A1E 75%)'};
const esc=s=>String(s==null?'':s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
const thumb=(u,w)=>u?u.replace(/([?&])width=\d+/,'$1width='+w):'';

function init(root){
  if(!root||root.dataset.t2On) return; root.dataset.t2On='1';
  const $=s=>root.querySelector(s), $$=s=>[...root.querySelectorAll(s)];
  const api={};   // what the theme editor and later steps can call (tab, spot, review, fitSw, syncArrows)

  // product data written by Liquid next to each card / dot: handle -> {t,u,img,ps,cs,off,from,rv,ra,o,v}
  // v = [variant id, option1, option2, option3, available, variant photo, price]
  const V={};
  $$('script[data-t2-p]').forEach(s=>{try{const d=JSON.parse(s.textContent);V[d.h]=d}catch(e){}});

  // how a product's quick add works: which option becomes the buttons, which one is the color
  const plan=h=>{
    const d=V[h]; if(!d) return null;
    const names=d.o.map(n=>String(n).toLowerCase());
    let q=names.findIndex(n=>n.includes('size'));
    const c=names.findIndex(n=>n.includes('color')||n.includes('colour'));
    if(q<0) q=(d.o.length===1)?0:d.o.length-1;
    const colors=c>=0&&c!==q?[...new Set(d.v.map(v=>v[1+c]))]:[];
    return {d,q,c:c!==q?c:-1,colors};
  };
  const variantFor=(p,color,val)=>p.d.v.find(v=>(p.c<0||v[1+p.c]===color)&&v[1+p.q]===val&&p.d.o.every((_,i)=>i===p.q||i===p.c||v[1+i]===p.d.v[0][1+i]));
  const findVariant=id=>{for(const h in V){const v=V[h].v.find(x=>String(x[0])===String(id));if(v)return {h,v}}return null};
  const single=p=>p.d.o.length===1&&p.d.o[0]==='Title';
  function qaButtons(h,color){
    const p=plan(h); if(!p) return '';
    if(single(p)){const v=p.d.v[0];return v[4]?`<button class="opt" type="button" data-id="${v[0]}">Add to cart</button>`:'<button class="opt" type="button" disabled>Sold out</button>'}
    let vals=[...new Set(p.d.v.map(v=>v[1+p.q]))];
    if(/size/i.test(p.d.o[p.q])) vals.sort((a,b)=>sizeRank(a)-sizeRank(b));
    return vals.map(val=>{const v=variantFor(p,color,val), label=String(val).replace('⭐','').replace(/\s*\(.*?\)\s*/g,' ').trim();
      return `<button class="opt" type="button" ${v&&v[4]?`data-id="${v[0]}"`:'disabled'} title="${esc(val)}">${esc(label)}</button>`}).join('');
  }
  function qaTitle(h){const p=plan(h);if(!p)return '';const n=p.d.o[p.q];return /size/i.test(n)?'Quick add · pick a size':(single(p)?'Quick add':'Quick add · '+esc(String(n).replace(/^(choose|select)( your)? /i,'')))}
  // the variant the card's Add to cart button buys: the chosen color, size L (or the nearest size in stock),
  // the first value of any other option; products without sizes take their first variant in stock
  const SIZE_PICK=['L','LARGE','M','MEDIUM','XL','X-LARGE','S','SMALL','XXL','2XL','XS','3XL','4XL','5XL'];
  function pickVariant(h,color){
    const p=plan(h); if(!p) return null;
    const ok=p.d.v.filter(v=>v[4]&&(p.c<0||!color||v[1+p.c]===color));
    if(!ok.length) return null;
    if(!/size/i.test(p.d.o[p.q])) return ok[0];
    const rank=v=>{const i=SIZE_PICK.indexOf(String(v[1+p.q]).toUpperCase().split(' ')[0]);return i<0?99:i};
    return ok.reduce((a,v)=>rank(v)<rank(a)?v:a);
  }
  const syncAtc=c=>{const b=c.querySelector('.cx-atc'); if(!b) return; const v=pickVariant(c.dataset.h,c.dataset.color); b.disabled=!v; b.textContent=v?'Add to cart':'Sold out'};
  // the product photo flies into the header's cart icon
  function fly(img){
    return new Promise(done=>{
      if(!img||matchMedia('(prefers-reduced-motion: reduce)').matches) return done();
      const from=img.getBoundingClientRect(); if(!from.width) return done();
      const icon=[...document.querySelectorAll('a[href="#offcanvas-cart"], [data-bs-target="#offcanvas-cart"]')].find(e=>{const r=e.getBoundingClientRect();return r.width&&r.height&&r.bottom>0});
      const to=icon?icon.getBoundingClientRect():{left:innerWidth-44,top:14,width:24,height:24};
      const c=document.createElement('img'); c.src=img.currentSrc||img.src; c.alt='';
      Object.assign(c.style,{position:'fixed',left:from.left+'px',top:from.top+'px',width:from.width+'px',height:from.height+'px',objectFit:'cover',borderRadius:'12px',
        boxShadow:'0 12px 30px rgba(0,0,0,.28)',zIndex:2147483000,pointerEvents:'none',margin:'0',transformOrigin:'center',
        transition:'transform .7s cubic-bezier(.55,0,.35,1), opacity .7s ease-in, border-radius .7s'});
      document.body.appendChild(c);
      const dx=(to.left+to.width/2)-(from.left+from.width/2), dy=(to.top+to.height/2)-(from.top+from.height/2), s=Math.max(26/from.width,.06);
      requestAnimationFrame(()=>requestAnimationFrame(()=>{c.style.transform=`translate(${dx}px,${dy}px) scale(${s})`;c.style.opacity='.4';c.style.borderRadius='50%'}));
      setTimeout(()=>{c.remove(); if(icon&&icon.animate) icon.animate([{transform:'scale(1)'},{transform:'scale(1.3)'},{transform:'scale(1)'}],{duration:380,easing:'ease-out'}); done()},720);
    });
  }

  // product cards come from Liquid; add the color dots, the quick add panel and a full Add to cart button
  $$('.pcard').forEach(c=>{
    const h=c.dataset.h, p=plan(h); if(!p) return;
    const first=p.colors[0]||''; c.dataset.color=first;
    const im=c.querySelector('img.main'); c.dataset.main=im?im.currentSrc||im.getAttribute('src'):'';
    if(p.colors.length>1){
      const sw=p.colors.map(col=>{
        const v=p.d.v.find(x=>x[1+p.c]===col), img=v&&v[5]?v[5]:'';
        const bg=img?`url('${thumb(img,80)}') center/cover`:(SWATCH[String(col).toLowerCase()]||'#ccc');
        return `<button type="button" aria-pressed="${col===first}" data-color="${esc(col)}" data-img="${esc(img)}" aria-label="${esc(col)}"><span style="background:${bg}"></span></button>`}).join('');
      const slot=c.querySelector('.meta > span:first-child'); if(slot) slot.outerHTML=`<div class="sw" role="group" aria-label="Color">${sw}</div>`;
    }
    c.querySelector('.im').insertAdjacentHTML('beforeend',`<div class="qa"><p>${qaTitle(h)} +</p><div class="opts">${qaButtons(h,first)}</div></div><button class="qa-toggle" type="button" aria-label="Quick add">+</button>`);
    // Add to cart goes straight into the cart (size L); the quick add panel on the photo still picks other sizes
    c.querySelector('.info').insertAdjacentHTML('beforeend','<button class="cx-atc" type="button">Add to cart</button>');
    syncAtc(c);
  });

  // color dots must stay inside the card: when the row (dots + rating) is too wide for the card, the last dots
  // give way to a "+N" chip that opens the product; the chosen color is never hidden. Runs on every width change.
  const fitSw=c=>{
    const meta=c.querySelector('.meta'), sw=c.querySelector('.sw'); if(!meta||!sw||!meta.clientWidth) return;
    const dots=[...sw.querySelectorAll('button')]; dots.forEach(b=>b.hidden=false);
    let more=sw.querySelector('.sw-more'); if(more) more.remove();
    const lim=meta.getBoundingClientRect().right+.5, over=()=>[...meta.children].some(x=>x.getBoundingClientRect().right>lim);
    if(!over()) return;
    more=document.createElement('a'); more.className='sw-more'; more.href=(c.querySelector('.info h3 a')||{}).href||'#';
    sw.appendChild(more);
    let n=0;
    for(let i=dots.length-1;i>=0;i--){
      if(dots[i].getAttribute('aria-pressed')==='true') continue;
      dots[i].hidden=true; n++; more.textContent='+'+n; more.setAttribute('aria-label',`${n} more colors`);
      if(!over()) break;
    }
  };
  const fitAll=()=>$$('.cx-grid:not([hidden]) .pcard').forEach(fitSw);
  api.fitSw=fitAll;
  fitAll(); setTimeout(fitAll,300); addEventListener('load',fitAll); addEventListener('resize',fitAll);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fitAll);

  // small notice for errors
  const toast=document.createElement('div');toast.className='t2toast';toast.setAttribute('role','status');root.appendChild(toast);
  let toastT;const say=h=>{toast.innerHTML=h;toast.classList.add('on');clearTimeout(toastT);toastT=setTimeout(()=>toast.classList.remove('on'),2800)};

  // add to the theme's own cart and open its drawer (or go to the cart page when the drawer is off)
  async function add(id,btn,img){
    if(btn.classList.contains('busy')) return;
    btn.classList.add('busy');
    try{
      const [r]=await Promise.all([fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:1}]})}),fly(img)]);
      const drawer=document.getElementById('offcanvas-cart');
      if(root.dataset.drawer==='1'&&drawer&&typeof window.refreshCartContents==='function'){
        window.refreshCartContents(r);
        if(window.bootstrap&&window.bootstrap.Offcanvas) window.bootstrap.Offcanvas.getOrCreateInstance(drawer).show();
      }else if(r.ok){location.href=ROOT+'cart'}
      else{const d=await r.json().catch(()=>({}));say(esc(d.description||d.message||'Could not add to cart'))}
    }catch(e){say('Could not add to cart. Please try again.')}
    finally{btn.classList.remove('busy')}
  }

  root.addEventListener('click',e=>{
    // color dot on a card: switch the photo (when the variant has one) and the option buttons
    const b=e.target.closest('.pcard .sw button');
    if(b){
      const c=b.closest('.pcard'); c.dataset.color=b.dataset.color;
      c.querySelectorAll('.sw button').forEach(x=>x.setAttribute('aria-pressed',x===b));
      const im=c.querySelector('img.main'), next=b.dataset.img?thumb(b.dataset.img,700):c.dataset.main;
      if(im&&im.getAttribute('src')!==next){im.style.opacity=0;const pre=new Image();pre.onload=pre.onerror=()=>{im.removeAttribute('srcset');im.src=next;im.style.opacity=1};pre.src=next}
      c.querySelector('.qa .opts').innerHTML=qaButtons(c.dataset.h,b.dataset.color);
      syncAtc(c);
      return;
    }
    // + on touch screens opens the quick add panel
    const t=e.target.closest('.qa-toggle');
    if(t){const c=t.closest('.pcard'),open=!c.classList.contains('qa-open');
      $$('.pcard.qa-open').forEach(x=>{x.classList.remove('qa-open');x.querySelector('.qa-toggle').textContent='+'});
      c.classList.toggle('qa-open',open);t.textContent=open?'×':'+';return}
    // card button: straight into the cart with the chosen color and size L
    const atc=e.target.closest('.pcard .cx-atc');
    if(atc){if(atc.disabled) return; const c=atc.closest('.pcard'), v=pickVariant(c.dataset.h,c.dataset.color);
      if(v) add(v[0],atc,c.querySelector('img.main')); return}
    // a size in the quick add panel, or the shop-the-look button
    const o=e.target.closest('.qa .opt[data-id], button.stl-atc[data-id]');
    if(o&&o.dataset.id) add(o.dataset.id,o,o.closest('.pcard')?o.closest('.pcard').querySelector('img.main'):root.querySelector('.stl-card .stl-img img'));
  });

  // ---- sideways rows (collection products, blog posts) on phones:
  // < > buttons level with the first photo that hide at the ends, and mouse dragging (for desktop previews, e.g. the theme editor)
  const dragScroll=el=>{
    if(!el||el.t2drag) return; el.t2drag=1;
    let sx=0, sl=0, down=false, moved=false;
    el.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0||el.scrollWidth<=el.clientWidth+2) return; down=true; moved=false; sx=e.clientX; sl=el.scrollLeft});
    el.addEventListener('pointermove',e=>{
      if(!down) return; const dx=e.clientX-sx;
      if(!moved&&Math.abs(dx)>6){moved=true; el.style.scrollSnapType='none'; el.style.cursor='grabbing'}
      if(moved){el.scrollLeft=sl-dx; e.preventDefault()}
    });
    addEventListener('pointerup',()=>{if(!down) return; down=false; if(moved){el.style.cursor=''; setTimeout(()=>{el.style.scrollSnapType=''},60)}});
    // a drag is not a click on the card or post under the pointer
    el.addEventListener('click',e=>{if(moved){e.preventDefault(); e.stopPropagation(); moved=false}},true);
    el.addEventListener('dragstart',e=>e.preventDefault());
  };
  const railArrows=(rail,scroller,itemSel,photoSel)=>{
    const prv=rail&&rail.querySelector('.cx-arrow.prev'), nxt=rail&&rail.querySelector('.cx-arrow.next'); if(!prv||!nxt) return null;
    const sync=()=>{
      const g=scroller(); if(!g) return; dragScroll(g);
      const max=g.scrollWidth-g.clientWidth-4, im=g.querySelector(photoSel);
      if(im&&im.offsetHeight){const top=im.getBoundingClientRect().top-rail.getBoundingClientRect().top+im.offsetHeight/2; prv.style.top=nxt.style.top=top+'px'}
      prv.classList.toggle('off',g.scrollLeft<=4); nxt.classList.toggle('off',max<=0||g.scrollLeft>=max);
    };
    const step=d=>{const g=scroller(), c=g&&g.querySelector(itemSel); if(!c) return; const gap=parseFloat(getComputedStyle(g).columnGap)||12;
      g.scrollBy({left:d*(c.offsetWidth+gap),behavior:'smooth'}); setTimeout(sync,450)};
    prv.addEventListener('click',()=>step(-1)); nxt.addEventListener('click',()=>step(1));
    rail.addEventListener('scroll',sync,true); addEventListener('resize',sync);
    rail.querySelectorAll('img').forEach(i=>{if(!i.complete) i.addEventListener('load',sync,{once:true})});
    sync(); return sync;
  };

  // ---- shop by collection: a tab swaps the banner photo and copy, and shows its own products
  const cx=$('.cx');
  if(cx){
    const img=cx.querySelector('.cx-img'), src=cx.querySelector('.cx-banner source'), copy=cx.querySelector('.cx-copy'),
          bar=cx.querySelector('.cx-tabs'), tabs=[...bar.querySelectorAll('[role=tab]')], phone=matchMedia('(max-width:700px)'),
          see=cx.querySelector('.cx-see a');
    tabs.forEach(t=>{const u=phone.matches?t.dataset.imgm:t.dataset.img; if(u) new Image().src=u});   // preload, so a switch is instant
    const apply=t=>{
      const d=t.dataset;
      if(src) src.srcset=d.imgm; img.src=d.img; img.style.setProperty('--pos',d.pos); img.style.setProperty('--posm',d.posm);
      copy.querySelector('.k').textContent=t.textContent;
      copy.querySelector('h2').innerHTML=`${esc(d.t1)}<em>${esc(d.t2)}</em>`;
      copy.querySelector('p').textContent=d.sub;
      const a=copy.querySelector('.cx-btn'); a.href=d.href; a.querySelector('span').textContent=d.btn;
      tabs.forEach(x=>{const g=document.getElementById(x.getAttribute('aria-controls')); if(g){g.hidden=x!==t; if(x===t) g.scrollLeft=0}});
      if(see){see.href=d.href; see.textContent=`${cx.dataset.see||'See all'} ${d.see} ›`}
    };
    const show=t=>{
      if(t.getAttribute('aria-selected')==='true') return;
      tabs.forEach(x=>{const on=x===t; x.setAttribute('aria-selected',on); x.tabIndex=on?0:-1});
      bar.scrollTo({left:t.offsetLeft-(bar.clientWidth-t.offsetWidth)/2,behavior:'smooth'});
      cx.classList.add('swap');
      setTimeout(()=>{apply(t);cx.classList.remove('swap');api.fitSw&&api.fitSw();api.syncArrows&&api.syncArrows()},200);
    };
    tabs.forEach(t=>t.addEventListener('click',()=>show(t)));
    bar.addEventListener('keydown',e=>{
      const i=tabs.indexOf(document.activeElement), step=e.key==='ArrowRight'?1:e.key==='ArrowLeft'?-1:0;
      if(i<0||!step) return; e.preventDefault();
      const t=tabs[(i+step+tabs.length)%tabs.length]; t.focus(); show(t);
    });
    api.tab=show;
    // phones: < > on both sides of the product row
    const crail=cx.querySelector('.cx-rail');
    api.syncArrows=crail&&railArrows(crail,()=>crail.querySelector('.cx-grid:not([hidden])'),'.pcard','.pcard .im');
  }

  // blog posts: the same < > on phones
  const brail=$('.blog-rail'); if(brail) railArrows(brail,()=>brail.querySelector('.posts'),'.post','.post .ph');

  // ---- shop the look: each dot shows its product in the card beside the photo
  const card=$('.stl-card'), spots=$$('.spot');
  spots.forEach(d=>{
    const p=V[d.dataset.k]; if(!p) return;
    const x=parseFloat(d.style.left), y=parseFloat(d.style.top);
    // the tooltip opens upward for low dots and hugs the edge for dots near the sides, so it is never cut off
    d.insertAdjacentHTML('beforeend',`<span class="tip" aria-hidden="true">${p.img?`<img src="${thumb(p.img,120)}" alt="">`:''}<span><b>${esc(p.t)}</b><i>${p.from?'From ':''}${p.ps}</i></span></span>`);
    d.classList.toggle('up',y>55); d.classList.toggle('al',x<18); d.classList.toggle('ar',x>72);
  });
  function stlPicker(h,p,c){
    if(!p||single(p)) return '';
    const name=String(p.d.o[p.q]).replace(/^(choose|select)( your)? /i,'').replace(/:$/,'');
    return `<p class="stl-lbl">${esc(name.charAt(0).toUpperCase()+name.slice(1))}</p><div class="stl-opts">${qaButtons(h,c)}</div>`;
  }
  function stlHtml(h,color){
    const d=V[h], p=plan(h);
    const c=color||(p&&p.colors.length?p.colors[0]:'');
    const v=p&&c?p.d.v.find(x=>x[1+p.c]===c&&x[5]):null;
    const sw=p&&p.colors.length>1?`<div class="stl-row"><p class="stl-lbl">Color: <b>${esc(c)}</b></p><div class="stl-sw" role="group" aria-label="Color">${p.colors.map(x=>{const vx=p.d.v.find(y=>y[1+p.c]===x&&y[5]);return `<button type="button" data-color="${esc(x)}" aria-pressed="${x===c}" aria-label="${esc(x)}"><span style="background:${vx?`url('${thumb(vx[5],80)}') center/cover`:(SWATCH[String(x).toLowerCase()]||'#ccc')}"></span></button>`}).join('')}</div></div>`:'';
    return `<a class="stl-img" href="${d.u}" tabindex="-1" aria-hidden="true"><img src="${color&&v?thumb(v[5],700):d.img}" alt=""></a>
    <div class="stl-head">
      <h3><a href="${d.u}">${esc(d.t)}</a></h3>
      <div class="stl-meta">
        <div class="price">${d.from?'<small>From</small>':''}${d.ps}${d.cs?`<s>${d.cs}</s><span class="pct">-${d.off}%</span>`:''}</div>
        ${d.rv?`<span class="stl-rv"><i>★</i> ${Number(d.ra).toFixed(1)} <em>(${Number(d.rv).toLocaleString('en-US')})</em></span>`:''}
      </div>
    </div>
    <div class="stl-body" data-h="${esc(h)}">
      ${sw}
      ${stlPicker(h,p,c)}
      <button class="stl-atc" type="button">Add to cart</button>
      <a class="stl-more" href="${d.u}">View full details</a>
    </div>`;
  }
  function stlChoose(o){
    const atc=card.querySelector('button.stl-atc'); if(!atc) return;
    card.querySelectorAll('.stl-opts .opt').forEach(x=>x.setAttribute('aria-pressed',x===o));
    // no picker = single-variant product; a picker with nothing available = sold out
    const d=V[card.querySelector('.stl-body').dataset.h], one=!card.querySelector('.stl-opts')&&d;
    const id=o?o.dataset.id:(one&&one.v[0][4]?one.v[0][0]:'');
    const f=id&&findVariant(id);
    atc.dataset.id=id||''; atc.disabled=!id;
    // the price comes from Shopify's money format, which can carry markup (<span class=money>) for currency apps
    atc.innerHTML=f?`Add to cart · ${f.v[6]}`:'Sold out';
  }
  // size L (or the nearest size in stock) is chosen to start with, as on the product cards
  const stlRender=(h,color)=>{
    card.innerHTML=stlHtml(h,color);
    const p=plan(h), v=pickVariant(h,color||(p&&p.colors[0])||'');
    stlChoose((v&&card.querySelector(`.stl-opts .opt[data-id="${v[0]}"]`))||card.querySelector('.stl-opts .opt[data-id]'));
  };
  let stlK=null;
  const stlShow=h=>{
    if(!card||!V[h]||h===stlK) return; stlK=h;
    spots.forEach(d=>{d.classList.toggle('on',d.dataset.k===h);d.setAttribute('aria-pressed',d.dataset.k===h)});
    card.classList.add('swap');
    setTimeout(()=>{stlRender(h);card.classList.remove('swap')},180);
  };
  spots.forEach(d=>{
    d.addEventListener('click',()=>stlShow(d.dataset.k));
    d.addEventListener('mouseenter',()=>{if(matchMedia('(hover:hover)').matches)stlShow(d.dataset.k)});
  });
  card&&card.addEventListener('click',e=>{
    const b=e.target.closest('.stl-sw button');
    if(b){stlRender(card.querySelector('.stl-body').dataset.h,b.dataset.color);return}
    const o=e.target.closest('.stl-opts .opt[data-id]');
    if(o) stlChoose(o);
  });
  if(spots.length) stlShow(spots[0].dataset.k);
  api.spot=d=>stlShow(d.dataset.k);

  // ---- reviews coverflow: the active card in the middle, the others step back smaller, darker and blurred;
  // arrows, a click on a side card, swipe or the arrow keys move it, and it wraps around
  const flow=$('.rv-flow');
  if(flow){
    const cards=[...flow.querySelectorAll('.rvc')], n=cards.length;
    let cur=0;
    const SC=[1,.8,.64,.52,.42], BL=[0,2,4,6,8], BR=[1,.5,.38,.3,.25], GAP=22;
    const layout=()=>{
      if(!n) return;
      const w=cards[0].offsetWidth, phone=matchMedia('(max-width:700px)').matches, far=phone?1:3;
      const X=[0]; for(let k=1;k<=4;k++) X[k]=X[k-1]+w*SC[k-1]/2+(phone?10:GAP)+w*SC[k]/2;
      cards.forEach((c,i)=>{
        let d=((i-cur)%n+n)%n; if(d>n/2) d-=n;
        // the card halfway round stays on the side it was on, so it slips out (or in) at the edge instead of crossing over
        if(Math.abs(d)===n/2&&c._d<0) d=-d;
        // a far card that changes sides jumps (unseen) to the far edge of its new side before sliding in
        if(c._d!==undefined&&Math.sign(c._d)!==Math.sign(d)&&Math.abs(c._d)>=2&&Math.abs(d)>=2){
          c.style.transition='none'; c.style.opacity=0; c.style.transform=`translateX(${Math.sign(d)*X[4]}px) scale(${SC[4]})`; void c.offsetWidth; c.style.transition='';
        }
        c._d=d;
        const a=Math.min(Math.abs(d),4), vis=Math.abs(d)<=far;
        c.style.transform=`translateX(${Math.sign(d)*X[a]}px) scale(${SC[a]})`;
        c.style.filter=a?`blur(${BL[a]}px) brightness(${BR[a]})`:'none';
        c.style.opacity=vis?1:0; c.style.zIndex=10-a; c.style.pointerEvents=vis?'auto':'none';
        c.classList.toggle('on',d===0); c.setAttribute('aria-hidden',d!==0);
        c.querySelectorAll('a').forEach(x=>x.tabIndex=d===0?0:-1);
      });
    };
    const go=i=>{if(!n)return;cur=(i%n+n)%n;layout()};
    flow.querySelector('.rv-nav.prev').addEventListener('click',()=>go(cur-1));
    flow.querySelector('.rv-nav.next').addEventListener('click',()=>go(cur+1));
    cards.forEach((c,i)=>c.addEventListener('click',e=>{if(i!==cur){e.preventDefault();go(i)}}));
    flow.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();go(cur-1)}else if(e.key==='ArrowRight'){e.preventDefault();go(cur+1)}});
    let sx=null; flow.addEventListener('pointerdown',e=>{sx=e.clientX},{passive:true});
    flow.addEventListener('pointerup',e=>{if(sx===null)return; const dx=e.clientX-sx; sx=null; if(Math.abs(dx)>40) go(cur+(dx<0?1:-1))},{passive:true});
    addEventListener('resize',layout); layout();
    // photos change the card height once they load
    flow.querySelectorAll('img').forEach(im=>{if(!im.complete) im.addEventListener('load',layout,{once:true})});
    api.review=c=>go(cards.indexOf(c));
  }
  root._t2=api;
}

const all=()=>document.querySelectorAll('.t2.t2-sections[data-section]').forEach(init);
window.T2Home={all,init};
all();
// theme editor: start a reloaded section again, and follow the block the merchant selects
document.addEventListener('shopify:section:load',e=>init(document.getElementById('t2-'+e.detail.sectionId)));
document.addEventListener('shopify:block:select',e=>{
  const el=e.target, root=el.closest&&el.closest('.t2.t2-sections'), api=root&&root._t2; if(!api) return;
  if(el.matches('[role=tab]')&&api.tab) api.tab(el);
  else if(el.classList.contains('spot')&&api.spot) api.spot(el);
  else if(el.classList.contains('rvc')&&api.review) api.review(el);
});
})();

// ===== 2TACTIC collections menu =====
// 2TACTIC collections menu (part of t2-homepage.js; loaded by sections/t2-collections-menu.liquid and the homepage section).
// Reads its content from <script type="application/json" id="t2nav-data"> and attaches to the theme's own menu item
// whose link is the "trigger" path (/collections): a mega panel under the desktop navbar; on phones the highlighted
// collections sit at the top of the slide-out menu and the rest folds out under that item.
// It can rebuild itself (the theme editor reloads sections), and its listeners are delegated so they never double up.
(()=>{
if(window.T2Nav){window.T2Nav.build();return}
const esc=s=>String(s==null?'':s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const FLAME='<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 16c3.314 0 6-2 6-5.5 0-1.5-.5-4-2.5-6 .25 1.5-1.25 2-1.25 2C11 4 9 .5 6 0c.357 2 .5 4-2 6-1.25 1-2 2.729-2 4.5C2 14 4.686 16 8 16m0-1c-1.657 0-3-1-3-2.75 0-.75.25-2 1.25-3C6.125 10 7 10.5 7 10.5c-.375-1.25.5-3.25 2-3.5-.179 1-.25 2 1 3 .625.5 1 1.364 1 2.25C11 14 9.657 15 8 15"/></svg>';
const CHEV='<svg class="t2nav-chev" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 4.5 6 8l3.5-3.5"/></svg>';
// tactical illustrated icons for the highlighted collections: flat colors, dark outline
// (flame patch, dog tag, ammo can, rank-chevron shield)
const IO='#1F1C1A';
const ICONS={
  patch:`<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 2.5 27.5 9v14L16 29.5 4.5 23V9z" fill="#3D4230" stroke="${IO}" stroke-width="1.6" stroke-linejoin="round"/><path d="M16 5.3 25 10.4v11.2l-9 5.1-9-5.1V10.4z" fill="none" stroke="#C8A86B" stroke-width="1" stroke-dasharray="1.6 1.3" stroke-linejoin="round"/><g transform="translate(8.3 9.4) scale(.48)"><path d="M16 3c1.5 4.5 6.5 6.5 7.5 12 1 5.5-2.5 12-8 12S7 23 7.5 18.5c.4-3.5 2.5-5 4-7 .3 2.3 1.3 3.5 2.5 4C13.2 11 14.5 6.5 16 3z" fill="#FF7A1A" stroke="${IO}" stroke-width="2.8" stroke-linejoin="round"/><path d="M16 15c1.5 2.5 4 3.5 4 6.5 0 2.5-1.8 4-4.2 4s-4-1.7-3.8-3.9c.2-1.8 1.5-2.8 2.3-4.1.3 1.1.9 1.7 1.6 1.9-.4-1.6-.3-3 .1-4.4z" fill="#FFC83D" stroke="${IO}" stroke-width="2" stroke-linejoin="round"/></g></svg>`,
  dogtag:`<svg viewBox="0 0 32 32" aria-hidden="true"><g fill="#9AA1A8" stroke="${IO}" stroke-width=".6"><circle cx="13.9" cy="6.9" r=".95"/><circle cx="12.4" cy="5.4" r=".95"/><circle cx="10.9" cy="3.9" r=".95"/><circle cx="9.4" cy="2.4" r=".95"/></g><rect x="7" y="7" width="18" height="22.5" rx="6.5" fill="#C9CED3" stroke="${IO}" stroke-width="1.6"/><rect x="9.6" y="9.6" width="12.8" height="17.3" rx="4.4" fill="none" stroke="#8E959C" stroke-width="1"/><circle cx="16" cy="10.6" r="1.3" fill="#5E656C" stroke="${IO}" stroke-width=".9"/><path d="m12.9 23.6 6.2-8.4" stroke="#D64545" stroke-width="2" stroke-linecap="round"/><circle cx="13.2" cy="16" r="1.75" fill="#D64545"/><circle cx="18.8" cy="22.8" r="1.75" fill="#D64545"/></svg>`,
  ammo:`<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M12 8.6V5.8h8v2.8" fill="none" stroke="#5E656C" stroke-width="2" stroke-linejoin="round"/><rect x="3.5" y="11.2" width="25" height="15.8" rx="1.6" fill="#6B7D3A" stroke="${IO}" stroke-width="1.6"/><rect x="2.8" y="8.2" width="26.4" height="4.2" rx="1" fill="#55652C" stroke="${IO}" stroke-width="1.6"/><rect x="24.6" y="13.2" width="2.6" height="5.4" rx=".6" fill="#4A4F55" stroke="${IO}" stroke-width="1"/><path d="M18.4 16.3c-.5-.6-1.3-.9-2.1-.9-1.2 0-2 .6-2 1.5 0 2.1 4.4 1 4.4 3.3 0 .9-.9 1.6-2.2 1.6-1 0-1.8-.4-2.4-1M16.2 14.2v1.2M16.2 21.9v1.2" fill="none" stroke="#E9DDAE" stroke-width="1.6" stroke-linecap="round"/></svg>`,
  crest:`<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 2.8 26.5 6.6v8.2c0 6.7-4.4 11.1-10.5 13.9C9.9 25.9 5.5 21.5 5.5 14.8V6.6z" fill="#D4A44A" stroke="${IO}" stroke-width="1.6" stroke-linejoin="round"/><path d="M16 5.8 23.9 8.7v6.1c0 5.2-3.2 8.6-7.9 10.9z" fill="#E9C46E"/><path d="m16 7.6 1.25 2.55 2.8.4-2.03 1.98.48 2.8L16 14l-2.5 1.33.48-2.8-2.03-1.98 2.8-.4z" fill="#fff" stroke="${IO}" stroke-width="1" stroke-linejoin="round"/><path d="m10.6 17.6 5.4 3 5.4-3M10.6 21.2l5.4 3 5.4-3" fill="none" stroke="${IO}" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>`
};
ICONS.flame=ICONS.patch; ICONS.sale=ICONS.percent=ICONS.dogtag; ICONS.cash=ICONS.dollar=ICONS.ammo; ICONS.shield=ICONS.crest;

let D={}, timer=0, openedAt=0;
const byId=id=>document.getElementById(id);
const norm=p=>String(p||'').replace(/\/+$/,'')||'/';
const isTrigger=a=>{try{const p=norm(new URL(a.getAttribute('href'),location.href).pathname), t=norm(D.trigger||'/collections');return p===t||p.endsWith(t)}catch(e){return false}};

const tiles=()=>`<div class="t2nav-tiles">${(D.tiles||[]).map(t=>`<a class="t2nav-tile" href="${esc(t.u)}">${t.img?`<img src="${esc(t.img)}" alt="" loading="lazy">`:''}<span class="t2nav-cap"><b>${esc(t.t)}</b>${t.n?`<small>${esc(t.n)} products</small>`:''}</span></a>`).join('')}</div>`;
const hot=()=>(D.hot||[]).length?`<div class="t2nav-hot">${D.hot.map(h=>`<a class="t2nav-hotc" href="${esc(h.u)}"><span class="t2nav-ico">${ICONS[h.icon]||ICONS.patch}</span><b class="t2nav-ht">${esc(h.t)}</b></a>`).join('')}</div>`:'';
const list=()=>(D.list||[]).length?`<ul class="t2nav-list">${D.list.map(l=>`<li><a href="${esc(l.u)}"><span class="t2nav-ph">${esc(String(l.t).trim().charAt(0).toUpperCase())}</span>${esc(l.t)}</a></li>`).join('')}</ul>`:'';
const all=()=>`<a class="t2nav-all" href="${esc(D.all_url||'/collections')}">${esc(D.all_text||'View all collections')} <span aria-hidden="true">→</span></a>`;

// ---- desktop panel state
const panel=()=>byId('t2nav-mega'), trig=()=>document.querySelector('.t2nav-trigger');
const isOpen=()=>{const p=panel();return !!p&&p.classList.contains('open')};
const open=()=>{clearTimeout(timer);const p=panel(),t=trig();if(!p||isOpen())return;openedAt=Date.now();p.classList.add('open');t&&t.setAttribute('aria-expanded','true')};
const close=()=>{clearTimeout(timer);const p=panel(),t=trig();if(!p)return;p.classList.remove('open');t&&t.setAttribute('aria-expanded','false')};
const later=()=>{clearTimeout(timer);timer=setTimeout(close,220)};
const hover=()=>matchMedia('(hover:hover)').matches;

// phones: the highlighted names stay on one line; on a very narrow drawer all of them shrink together
function fit(){
  const names=[...document.querySelectorAll('.t2nav-mtop .t2nav-ht')]; if(!names.length||!names[0].clientWidth) return;
  names.forEach(n=>n.style.fontSize='');
  let fs=parseFloat(getComputedStyle(names[0]).fontSize);
  while(fs>9.5&&names.some(n=>n.scrollWidth>n.clientWidth+.5)){fs-=.5; names.forEach(n=>n.style.fontSize=fs+'px')}
}

function build(){
  // take down a previous build first
  close();
  document.querySelectorAll('#t2nav-mega,#t2nav-m,.t2nav-mtop').forEach(e=>e.remove());
  document.querySelectorAll('.t2nav-trigger,.t2nav-mtrig').forEach(a=>{
    a.classList.remove('t2nav-trigger','t2nav-mtrig'); a.querySelectorAll('.t2nav-chev').forEach(c=>c.remove());
    ['aria-expanded','aria-controls','role'].forEach(x=>a.removeAttribute(x));
  });
  const src=byId('t2nav-data'); if(!src) return;
  try{D=JSON.parse(src.textContent)}catch(e){return}

  // desktop: mega panel under the navbar
  const nav=byId('navbar-desktop');
  const t=nav&&[...nav.querySelectorAll('a.nav-link')].find(isTrigger);
  if(t){
    const p=document.createElement('div');
    p.className='t2nav-mega'; p.id='t2nav-mega'; p.setAttribute('role','region'); p.setAttribute('aria-label',D.label||'Collections');
    p.innerHTML=`<div class="t2nav-in">${tiles()}<div class="t2nav-side">${(D.hot||[]).length?`<h4>${FLAME}${esc(D.hot_title||'Hot right now')}</h4>${hot()}`:''}${(D.list||[]).length?`<h4 class="t2nav-gap">${esc(D.list_title||'All collections')}</h4>${list()}`:''}${all()}</div></div>`;
    nav.appendChild(p);
    t.classList.add('t2nav-trigger'); t.insertAdjacentHTML('beforeend',CHEV);
    t.setAttribute('aria-expanded','false'); t.setAttribute('aria-controls','t2nav-mega'); t.setAttribute('role','button');
  }

  // phones: highlighted collections at the top of the slide-out menu, the rest folds out under the item
  const mnav=byId('offcanvas-menu-nav');
  if(mnav&&(D.hot||[]).length){
    const top=document.createElement('div');
    top.className='t2nav-m t2nav-mtop';
    top.innerHTML=`<h5>${FLAME}${esc(D.hot_title||'Hot right now')}</h5>${hot()}`;
    mnav.before(top);
    const oc=byId('offcanvas-menu');
    if(oc&&!oc.t2fit){oc.t2fit=1; oc.addEventListener('shown.bs.offcanvas',fit)}
    fit();
  }
  const mt=mnav&&[...mnav.querySelectorAll('a.nav-link')].find(isTrigger);
  if(mt&&((D.tiles||[]).length||(D.list||[]).length)){
    const box=document.createElement('div');
    box.className='t2nav-m'; box.id='t2nav-m';
    box.innerHTML=`${(D.tiles||[]).length?`<h5>${esc(D.shop_title||'Shop by category')}</h5>${tiles()}`:''}${(D.list||[]).length?`<h5>${esc(D.list_title||'All collections')}</h5>${list()}`:''}${all()}`;
    mt.after(box);
    // the theme draws its own plus / minus for menu items that have aria-expanded
    mt.classList.add('t2nav-mtrig');
    mt.setAttribute('aria-expanded','false'); mt.setAttribute('aria-controls','t2nav-m'); mt.setAttribute('role','button');
  }
}

// one set of listeners for every build
document.addEventListener('click',e=>{
  const t=e.target.closest('.t2nav-trigger');
  // a click right after the hover opened it keeps it open instead of shutting it again
  if(t){e.preventDefault(); isOpen()&&Date.now()-openedAt>400?close():open(); return}
  const m=e.target.closest('.t2nav-mtrig');
  if(m){e.preventDefault(); const b=byId('t2nav-m'); if(b){const o=b.classList.toggle('open'); m.setAttribute('aria-expanded',o)} return}
  if(isOpen()&&!e.target.closest('#t2nav-mega')) close();
});
document.addEventListener('mouseover',e=>{
  if(!hover()) return;
  if(e.target.closest('.t2nav-trigger')) open();
  else if(e.target.closest('#t2nav-mega')) clearTimeout(timer);
});
document.addEventListener('mouseout',e=>{
  if(!hover()||!isOpen()||!e.target.closest('.t2nav-trigger,#t2nav-mega')) return;
  const to=e.relatedTarget; if(to&&to.closest&&to.closest('.t2nav-trigger,#t2nav-mega')) return;
  later();
});
document.addEventListener('keydown',e=>{
  if(e.key==='Escape'&&isOpen()){close();const t=trig();t&&t.focus()}
  else if(e.key==='ArrowDown'&&e.target.closest&&e.target.closest('.t2nav-trigger')){e.preventDefault();open();const f=panel()&&panel().querySelector('a');f&&f.focus()}
});
document.addEventListener('focusout',e=>{
  const p=panel(); if(!p||!isOpen()||!p.contains(e.target)) return;
  const r=e.relatedTarget; if(r&&(p.contains(r)||(r.closest&&r.closest('.t2nav-trigger')))) return;
  close();
});
addEventListener('resize',fit);
// theme editor: rebuild when this section or the theme's navbar is reloaded, take everything down when removed
document.addEventListener('shopify:section:load',build);
document.addEventListener('shopify:section:unload',()=>setTimeout(build,0));

window.T2Nav={build};
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',build); else build();
})();
